<template>
  <v-file-input
    :id="id"
    :ref="refName"
    v-bind="$attrs"
    v-model="pValue"
    inset
    :label="label"
    :color="color"
    :hint="hint"
    :variant="variant"
    :dark="dark"
    :persistent-hint="!!hint"
    :accept="accept"
    :rules="rules.map((rule) => () => rule(modelValue))"
    multiple
    @keyup.enter="$emit('onEnter')"
    @update:model-value="onInputChanged($event)"
  >
    <template #append>
      <v-tooltip location="bottom">
        <template #activator="{ props }">
          <v-icon
            class="selector-default-help-icon"
            color="grey"
            size="18"
            v-bind="props"
          >
            mdi-help
          </v-icon>
        </template>
        <span>{{ helpText }}</span>
      </v-tooltip>
    </template>
  </v-file-input>
</template>


<script>
import { v4 as uuidv4 } from "uuid";

export default {
  name: "HelpFileInput",
  props: {
    id: {
      type: String,
      default: () => uuidv4(),
    },
    modelValue: {},
    color: {
      type: String,
      default: "primary",
    },
    hint: {
      type: String,
      default: "",
    },
    variant: {
      type: String,
      default: "filled",
    },
    dark: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    helpText: {
      type: String,
      default: "",
    },
    accept: {
      type: String,
      default: "",
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      pValue: this.value,
    };
  },
  computed: {
    refName() {
      return `${this.id}-help-input`;
    },
  },
  watch: {
    value(newVal) {
      this.pValue = newVal;
    },
  },

  methods: {
    onInputChanged(event) {
      const value = Array.isArray(event) ? event[0] : event;

      this.$emit("update:modelValue", value);
    },
     validate() {
      this.$refs[this.refName].validate();
    },
  },
};
</script>


<style lang="scss">
</style>